import React, {useEffect} from "react";
import Footer from '../user/components/footer';
import Header from "../user/components/header";

const ShippingOutsideIndia = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "instant"
        });
    }, []);


    return (
        <>
            <Header />
            <div className="sec_latestpd" style={{ marginTop: "150px" }}>
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-md-12">
                            <h2 className="sec_title">SHIPPING OUTSIDE INDIA</h2>
                            <hr />
                        </div>
                        <div className="col-md-12">
                            <p>We ship unframed artworks to all countries of the world. We charge a minimum shipping fee of $62 per artwork. For bigger and heavy artworks the price will be higher and it will reflect once you proceed to purchase. For customized art/craftwork in custom sizes, we will provide shipping quotes based on the same. <b>International buyers must note that our art/craft work costs DO NOT cover Custom Clearance Fees and Custom Duties when shipping outside India</b>. If these are applicable, these charges would be collected by the courier partner at the time of delivery, or they might connect to you before delivery, for collecting Custom Clearance Fees and Custom Duties charges. These charges vary from country to country and these charges are subject to changes also. To know more about Custom Clearance Fees and Custom Duties applicable to you you may write to our customer care at info@indigalleria.com </p>
                            <p>International shipping may take up to 15 Days.</p>
                            <p>Domestic shipping may take 5-10 days.</p>
                            <p>Last modified: 01 Jan 2023</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default ShippingOutsideIndia;